import { render, staticRenderFns } from "./lp-faculty-detail.vue?vue&type=template&id=9b5ed80c&scoped=true&"
import script from "./lp-faculty-detail.vue?vue&type=script&lang=js&"
export * from "./lp-faculty-detail.vue?vue&type=script&lang=js&"
import style0 from "./lp-faculty-detail.vue?vue&type=style&index=0&id=9b5ed80c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5ed80c",
  null
  
)

export default component.exports